/* @generated */
/* empty css                              */import { createRuntimeFn } from "@vanilla-extract/recipes/createRuntimeFn";
var fileIconContainerFallbackVar = "var(--dig-ctz1wx0_5-3-6, #f7f5f2)";
var fileIconShadowFallbackVar = "var(--dig-ctz1wx1_5-3-6, #c7c1bb)";
var contentIconRecipe = createRuntimeFn({ defaultClassName: "dig-ctz1wx2_5-3-6", variantClassNames: { over: { subtle: "dig-ctz1wx3_5-3-6", base: "dig-ctz1wx4_5-3-6" }, hasNoBackground: { true: "dig-ctz1wx5_5-3-6" } }, defaultVariants: { over: "base", hasNoBackground: false }, compoundVariants: [] });
export {
  contentIconRecipe,
  fileIconContainerFallbackVar,
  fileIconShadowFallbackVar
};
